import { ConstantsParser } from "../../../ConstantsParser";
export class Rotated {
  constructor() {
    this.name = 'Rotated'
    this.content = {
      class: 'fas',
      icon: 'fa-snowboarding'
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let iconClasses = (new ConstantsParser(this.iconClasses())).parse().join(' ')
    return `<i class="fas fa-snowboarding ${iconClasses}"/>`
  }

  classes() {
    return [
      {property: 'Display', value: 'FLEX'},
      {property: 'AlignItems', value: 'ALIGN_ITEMS_CENTER'},
      {property: 'JustifyContent', value: 'JUSTIFY_CENTER'},
    ]
  }

  iconClasses() {
    return [
      { property: 'IconSize', value: 'ICON_SIZE_LG' },
      { property: 'IconRotated', value: 'ICON_ROTATE_180' }
    ]
  }

  styles() {
    return []
  }

  iconStyles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      iconClasses: {
        desktop: this.iconClasses(),
        tablet: this.iconClasses(),
        phone: this.iconClasses(),
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
    }
  }
}
